import React from "react";
import NewCardImage from "../../../../assets/images/png/binance-news/new.webp";
import NewCard2Image from "../../../../assets/images/png/binance-news/new2.webp";
import TechpointImage from "../../../../assets/images/png/binance-news/techpoint.png";
import ThisdayliveImage from "../../../../assets/images/png/binance-news/thisdaylive.png";
import style from "./style.module.css";

import * as Animate from "react-reveal";

const Card = ({ date, title, linkUrl, image, cardImage }) => {
  return (
    <a
      href={linkUrl || "/"}
      target={"_blank"}
      rel="noopener noreferrer"
      className={`${style.card} px-8 py-8 rounded-2xl`}
    >
      <div className="flex flex-wrap flex-row justify-between items-center">
        <div className="w-3/12">
          <img src={image || TechpointImage} alt="" />
        </div>
        <div className="">
          <p className="text-xs lg:text-sm">{date}</p>
        </div>
      </div>

      <div className="mt-6 lg:mt-8 text-sm-15 lg:text-base w-11/12">
        {title}
      </div>

      <div className="mt-10 lg:mt-12">
        <img src={cardImage || NewCardImage} alt="News" />
      </div>
    </a>
  );
};

const NewsSection = () => {
  return (
    <section className="relative pt-20 lg:pt-24 pb-28 lg:pb-32">
      <div className="relative container mx-auto px-4">
        <div className="w-full lg:w-10/12 mx-auto">
          <Animate.Fade bottom>
            <h3 className="font-semibold text-2xl md:text-3xl lg:text-4xl text-primary text-center font-mono">
              Binance Charity in the news
            </h3>
            <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-12">
              <Card
                image={TechpointImage}
                date={"October 24, 2023"}
                linkUrl="https://techpoint.africa/2022/10/24/binance-charity-partners-with-utiva-to-educate-50000-youths-and-provide-tech-training-scholarships-to-over-1000-youth-across-africa"
                title={
                  "Binance Charity Partners with Utiva to Educate 50,000 Youths and Provide Tech Training/Scholarships to Over 1,000 Youth Across Africa"
                }
                cardImage={NewCard2Image}
              />
              <Card
                image={ThisdayliveImage}
                date={"October 28, 2023"}
                linkUrl="https://www.thisdaylive.com/index.php/2022/10/27/binance-charity-utiva-to-enhance-50000-youths-with-tech-skills-scholarships/"
                title={
                  "Binance Charity, Utiva to Enhance 50,000 Youths with Tech Skills, Scholarships"
                }
                cardImage={NewCardImage}
              />
            </div>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
